import Cookies from "js-cookie";

// Check if token expired (10 hours)
export const isTokenExpired = () => {
  const loginTime = sessionStorage.getItem("loginTime");
  const token = Cookies.get("jwt_token");

  if (!token || !loginTime) return true;

  const now = new Date().getTime();
  const TEN_HOURS = 10 * 60 * 60 * 1000;

  return now - parseInt(loginTime, 10) > TEN_HOURS;
};

// Logout user and redirect to login page
export const logoutUser = () => {
  sessionStorage.removeItem("loginTime");
  Cookies.remove("jwt_token");
  Cookies.remove("jwt_token", { path: "/" });
  window.location.href = "/"; // redirect to login
};
